// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@store/Overrides/Components/SmallHeadingAndText";
import BillingAndShippingInfo from "@store/Overrides/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";
import { infoProps } from "@store/Themes/common/props/info";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    curentBillToState: getCurrentBillToState(state),
    currentShipToState: getCurrentShipToState(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface OrderUploadInformationStyles {
    container?: GridContainerProps;
    infoGridItem?: GridItemProps;
    billingShippingGridItem?: GridItemProps;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
    titleText?: TypographyPresentationProps;
}

export const orderUploadInformationStyles: OrderUploadInformationStyles = {
    container: {
        css: css`
            ${spacingStyles(null, pxToRem(32))};
            gap: ${pxToRem(32)};
            padding-bottom: ${pxToRem(32)};
            border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

            &:last-child {
                padding-bottom: 0;
                border-bottom: 0;
            }
        `,
    },
    infoGridItem: {
        width: [12, 6, 4, 3, 3],
    },
    billingShippingGridItem: {
        width: 12,
    },
    headingAndTextStyles: {
        wrapper: {
            css: css`
                ${spacingStyles()}
                margin-bottom: ${pxToRem(20)};
            `,
        },
        heading: infoProps.label,
        text: infoProps.value,
    },
    titleText: {
        variant: "h4",
        forwardAs: "h3",
    },
};

const styles = orderUploadInformationStyles;

const OrderUploadInformation = ({ curentBillToState, currentShipToState }: Props) => {
    const language = useAppSelector(state => state.context.session.language);

    if (!curentBillToState.value || !currentShipToState.value) {
        return null;
    }

    const goBackToShipping = () => {};

    return (
        <GridContainer {...styles.container}>
            <GridItem width={12}>
                <Typography {...styles.titleText}>{translate("Order Information")}</Typography>
            </GridItem>
            <GridItem {...styles.infoGridItem}>
                <SmallHeadingAndText
                    extendedStyles={styles.headingAndTextStyles}
                    heading={translate("Order Date")}
                    text={getLocalizedDateTime({
                        dateTime: new Date(),
                        language,
                    })}
                />
            </GridItem>
            <GridItem width={12}>
                <BillingAndShippingInfo
                    billTo={curentBillToState.value}
                    shipTo={currentShipToState.value}
                    deliveryDate={null}
                    onEditBillTo={goBackToShipping}
                    onEditShipTo={goBackToShipping}
                    showBillingAddress
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderUploadInformation),
    definition: {
        displayName: "Greif Information",
        group: "Order Upload",
        allowedContexts: ["OrderUploadPage"],
    },
};

export default widgetModule;
